import React, { useState, useEffect } from 'react';
import { Spinner } from 'react-bootstrap';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import { pesquisacompedido } from '../../../../actions/credenciamento/credencial';
import { pesquisa as pesquisatraducoes } from '../../../../actions/traducoes/traducoes';

//Components
import Pedidos from '../../components/pendencias/Pedidos';
import Body from '../../../../components/layoutcredenciamento/Body';
import Footer from '../../../../components/layoutcredenciamento/Footer';
import Layout from '../../../../components/layoutcredenciamento/Layout';

import { setEvento } from '../../../../utils/eventosessioncred';

const Pendencias  = (props) => {
    
    const [credencial, setCredencial] = useState({});
    
    const load = async () => {

        const cred = await props.pesquisacompedido({
            idcredencial: Buffer.from(props.match.params.idcredencial, "base64").toString(),
            idpromotora: props.match.params.idpromotora,
            idevento: props.match.params.idevento
        });

        await props.pesquisatraducoes({
            idpromotora: props.match.params.idpromotora,
            idevento: props.match.params.idevento,
            wherein: JSON.stringify({
                campo: 'identificador',
                valores: ['pendencias','conf_index']
            })}
        );

        setEvento(cred[0].evento);
        setCredencial(cred[0]);
    }

    useEffect(() => {
        load();
    },[]);
    
    return (
        <Layout>            
            <Body>
                {props.pendingTasks?
                <Spinner animation="border" />
                :
                null
                }
                {!credencial.idcredencial?
                null
                :
                <Pedidos load={load} />
                }
            </Body>
            <Footer />
        </Layout>
    )    
}

const mapStateToProps = (state) => {
    return {
        pendingTasks: state.pendingTasks
    }
}

export default connect(mapStateToProps,{pesquisacompedido,pesquisatraducoes})(withRouter(Pendencias));